import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { tela } from "./analytics";

/**
 * Manda um "pageview" limpo a cada mudança de rota.
 *
 * ⚠️ POR QUE NÃO MANDAMOS A URL CRUA
 * Rotas como /video/abc-123 e /serie_details/xyz carregam IDS na URL. Mandar a URL crua
 * vazaria o id do conteúdo (e, num /admin/users/:id, o id de um usuário). Então cada rota
 * vira um NOME limpo — "video", "serie", "paywall" — sem o parâmetro.
 *
 * O nome também não distingue QUAL vídeo: só que a pessoa está numa tela de vídeo. Para o
 * funil do site (entrada → paywall → checkout → login) é tudo que precisamos.
 */

// caminho -> nome limpo. Ordem importa: o primeiro que casar vence.
const ROTAS = [
  [/^\/$/, "home"],
  [/^\/login/, "login"],
  [/^\/(signup|cadastro)/, "cadastro"],
  [/^\/esqueci-senha/, "esqueci_senha"],
  [/^\/(nova-senha|senha)/, "nova_senha"],
  [/^\/serie_details\//, "serie"],
  [/^\/video\//, "video"],
  [/^\/profile/, "perfil"],
  [/^\/privacy/, "privacidade"],
  [/^\/terms/, "termos"],
  // O painel admin é ferramenta interna — não é jornada de aquisição. Um nome só basta,
  // e não descemos ao /admin/users/:id (que traria id de usuário).
  [/^\/admin/, "admin"],
  [/^\/manager/, "admin"],
];

function nomeDaRota(pathname) {
  for (const [re, nome] of ROTAS) if (re.test(pathname)) return nome;
  return "outra";
}

export default function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    tela(nomeDaRota(location.pathname));
  }, [location.pathname]);

  return null;
}
